import { LuPalmtree } from 'react-icons/lu'
import { LiaCertificateSolid } from 'react-icons/lia'
import { PiMoney, PiOfficeChairFill, PiNotebookFill, PiNoteFill, PiFileDocBold } from 'react-icons/pi'
import { QuickAction } from '../components/MenuDashed/MenuDashed'
import { useState } from 'react'
import { OnVacation } from '../components/OnVacation/OnVacation'
import { useNavigate } from 'react-router-dom'
import { ContracsDashedMenu } from '../components/ContracsDashed/ContracsDashedMenu'
import { EmployeeID } from '../../../../Talentohumano/DigitalID/EmployeeID'
import { EmployeeIncapacity } from '../../../../Talentohumano/GestionTH/EmployeeIncapacity/EmployeeIncapacity'
import { PayrollProcess } from '../../../../admin/perfil/elements/PayrollProcess'
import { EmployeeFixedAssets } from '../../../../admin/perfil/elements/EmployeeFixedAssets'
import { EmployeeContract } from '../../../../admin/perfil/elements/EmployeeContract'

const useDashed = () => {
    const navigate = useNavigate();

    const [activeQA, setActiveQA] = useState<QuickAction | undefined>({
        icon: <LiaCertificateSolid />,
        label: 'Certificados',
        event: (e) => { setActiveQA(e) }
    })

    const example: QuickAction[] = [

        {
            icon: <LiaCertificateSolid />,
            label: 'Certificados',
            event: (e) => { setActiveQA(e) }
        },
        {
            icon: <PiMoney />,
            label: 'Nómina',
            event: (e) => { setActiveQA(e) }
        },
        {
            icon: <LuPalmtree />,
            label: 'Vacaciones',
            event: (e) => { setActiveQA(e) }
        },
        {
            icon: <PiOfficeChairFill />,
            label: 'Activos Fijos',
            event: (e) => { setActiveQA(e) }
        },
        {
            icon: <PiNotebookFill />,
            label: 'Carnet',
            event: (e) => { setActiveQA(e) }
        },
        {
            icon: <PiNoteFill />,
            label: 'Contratos Laborales',
            event: (e) => { setActiveQA(e) }
        },
        {
            icon: <PiFileDocBold />,
            label: 'Incapacidades',
            event: (e) => { setActiveQA(e) }
        },
    ]

    const renderSwitch = () => {
        switch (activeQA ? activeQA.label : '') {
            case 'Certificados': return (
                <EmployeeContract />
            )
            case 'Nómina': return (
                <PayrollProcess />
            )
            case 'Activos Fijos': return (
                <EmployeeFixedAssets />
            )
            case 'Vacaciones': return (
                <OnVacation />
            )
            case 'Contratos Laborales': return (
                <ContracsDashedMenu />
            )
            case 'Carnet': return (
                <EmployeeID />
            )
            case 'Incapacidades': return (
                <div className="row">
                    <div className="col-md-12 p-2">
                        <EmployeeIncapacity isModal componentProps={{ autoGestion: true, permisions: { canCreate: true, canDelete: true, canEdit: true, canRadicar: true } }} />
                    </div>
                </div>
            )
            default:
                break;
        }
    }

    return { example, activeQA, setActiveQA, renderSwitch }
}

export default useDashed